import { UserProfileTabsForm } from "./user-profile-tabs-form";
import { UserProfileTabsHandler } from "./user-profile-tabs-handler";
import { UserProfileTabsListener } from "./user-profile-tabs-listener";

export class UserProfileTabsSetup {
    public root: HTMLElement;

    public form: UserProfileTabsForm;

    public handler: UserProfileTabsHandler;

    public listener: UserProfileTabsListener;

    public constructor(root: HTMLElement) {
        this.root = root;
        this.form = new UserProfileTabsForm(root);
        this.handler = new UserProfileTabsHandler(this.form);
        this.listener = new UserProfileTabsListener(this.form, this.handler);
    }

    public init(): void {
        if (!(this.root instanceof HTMLElement)) return;
        const layoutRoot = this.form.getLayoutRoot();
        const tabsRoot = this.form.getTabsRoot();
        if (!(layoutRoot instanceof HTMLElement)) return;
        if (!(tabsRoot instanceof HTMLElement)) return;
        if (!Number.isFinite(this.form.getUserId()) || this.form.getUserId() <= 0) return;
        if (this.form.isInitialized()) return;

        this.form.markInitialized();
        this.listener.register();
        this.handler.bootstrap();
    }

    public static init(root: HTMLElement): void {
        const setup = new UserProfileTabsSetup(root);
        setup.init();
    }
}
